export const defaultUppyDialogConfig = {
  hideUploadButton: true,
  proudlyDisplayPoweredByUppy: false,
};
